<template>
    <div class="bank_title">
        <div class="bank_content">
            <div class="title_l">
                <div class="goback">
                    <img v-if="data.isShow" src="../assets/goback.png" alt="">
                    <span></span>
                </div>
                <div class="model">
                    <div class="model_item" :class="{ current_nav_l: activeNav === 'priseSlaughterIndex' }" @click="go(1)">
                        屠宰加工
                    </div>
                    <div class="model_item" style="margin-left: 1.13rem;"
                        :class="{ current_nav_l: activeNav ==='souceIndex' }" @click="go(6)">
                        商品溯源
                    </div>
                </div>
            </div>
            <!-- <span class="title_name">{{ data.name }}</span> -->
            <!-- userInfo.enterpriseModel.companyName|| -->
            <span class="title_name">{{userInfo.enterpriseModel&&userInfo.enterpriseModel.companyName||'锡林郭勒盟伊鑫牧业有限公司'}}生产指挥中心</span>
            <div class="title_r">
                <div class="timer">
                    <div class="model_item_1">
                        <span>{{ current }}</span>
                        <span>{{ week | weekFilter }}</span>
                    </div>
                    <div class="model_item_time">
                        {{ time }}
                    </div>
                </div>
                <div class="time">
                    <span @click="exitLogin">退出</span>
                    <!-- <label>{{time}}</label> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { parseTime } from '@/utils/format.js'
export default {

    data() {
        return {
            time: parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            userInfo: null,
            login: '',
            headDate: '',//判断是否为正蓝旗登录
            time: null,
            current: null,
            week: null,
            timer: null,//定时器,
            // myKey: '' || window.localStorage.getItem('MYKEY')
        };
    },
    props: {
        data: Object
    },
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        this.activeNav = this.$route.meta.activeNav
        // this.time = parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        // setInterval(() => {
        //     this.time = parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        // }, 1000)
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        console.log(this.userInfo,'7890777777');
        this.login = window.localStorage.getItem('LOGIN')
        // console.log( this.login,'this.login');
    },
    mounted() {
        this.getTime()
    },
    // 日期过滤
    filters: {
        weekFilter: (val) => {
            if (val == 0) return '星期天'
            if (val == 1) return '星期一'
            if (val == 2) return '星期二'
            if (val == 3) return '星期三'
            if (val == 4) return '星期四'
            if (val == 5) return '星期五'
            if (val == 6) return '星期六'

        }
    },
    watch: {},
    methods: {
        getTime() {
            this.current = new Date().toLocaleDateString().replace(/\//g, '.');//获取当前日期（“年/月/日”）
            this.week = new Date().getDay();//获取当前星期（0~6，0代表星期天）
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                var time = new Date().toLocaleTimeString();//获取当前时间
                this.time = time
            }, 1000)
        },
        // 跳转供销社
        goShort() {
            // console.log(window.location.href);
            location.href = `https://www.91xumu.com/supplyScreen/#/index?sourceURL=${window.location.href}`
        },
        exitLogin() {
            this.$router.push({ path: this.login })
            window.localStorage.removeItem('mapfileUrl')
            window.localStorage.removeItem('NMYDATAUSERINFO')
            window.localStorage.removeItem('NMYDATAASSTSTOKEN')
            window.localStorage.removeItem('LOGIN')
            // this.$router.push({ path: '/login' })
        },
        goback() {
            this.$router.go(-1)
        },
        go(type) {
            switch (type) {
                case 1:
                    this.$router.push({ name: 'priseSlaughter' })
                    break;
                // case 2:
                //     this.$router.push({ name: 'traceIndex' })
                //     break;
                // case 3:
                //     this.$router.push({ name: 'financial' })
                //     break;
                // case 4:
                //     this.$router.push({ name: 'user' })
                //     break;
                // case 5:
                //     this.$router.push({ name: 'transaction' })
                //     break;
                case 6:
                    this.$router.push({ name: 'souceIndex' })
                    break;
                // case 7:
                //     this.$router.push({ name: 'livestock' })
                //     break;
                // case 8:
                //     this.$router.push({ name: 'slaughter' })
                //     break;
                // case 9:
                //     this.$router.push({ name: 'empty_3' })
                //     break;
                default:
                    this.$router.push({ name: 'empty' })
            }
        }

    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        background: #020e2a;

        .bank_content {
            height: 1rem;
            // background-image: url("../assets/data_title_bg.png");
            background-size: 100% 100%;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            background: linear-gradient(360deg, rgba(0, 224, 219, 0.12) 0%, rgba(2, 18, 41, 0.52) 100%);

            .title_name {
                display: block;
                flex: 1;
                // height: 1rem;
                // padding-bottom: 0.24rem;
                // line-height: .9rem;

                text-align: center;
                font-size: 0.5rem;
                font-family: 045-SSYiFeiTi-Regular, 045-SSYiFeiTi;
                font-weight: 400;
                color: #00E0DB;
                line-height: 1rem;
                letter-spacing: 1px;
                font-style: italic
            }

            .title_l,
            .title_r {
                // height: 0.78rem;
                width: 5.5rem;
                // width: 7.4rem;
                display: flex;
                // justify-content: space-between;
                // padding-bottom: 0.24rem;

                .timer {
                    // position: absolute;
                    // left: .5rem;
                    // top: .35rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .model_item_time {
                        // width: 1.7rem;
                        // height: 0.52rem;
                        font-size: 0.38rem;
                        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                        font-weight: bold;
                        color: #fff;
                        cursor: pointer;
                        padding-left: .2rem;
                    }

                    .model_item_1 {
                        min-width: 2rem;
                        height: 0.27rem;
                        font-size: 0.2rem;
                        font-family: Source Han Sans-Regular, Source Han Sans;
                        font-weight: 400;
                        color: #E9F7FF;
                        line-height: 0.3rem;
                        margin-left: .5rem;

                        span:nth-child(2) {
                            margin-left: .2rem;
                        }
                    }
                }

                .model {
                    display: flex;
                }

                .model_item {
                    // width: 1.7rem;
                    // width: 1.4rem;
                    min-width: 1.35rem;
                    // height: 0.52rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // background-image: url("../assets/btn_bg_1.png");
                    // background-image: url("../assets/new_bg_2.png");
                    background-size: 100% 100%;
                    font-size: 0.28rem;
                    font-family: 045-SSYiFeiTi-Regular, 045-SSYiFeiTi;
                    font-weight: 400;
                    color: rgba(0, 224, 219, 0.51);
                    cursor: pointer;
                    // margin-top: .1rem;
                    letter-spacing: 2px;
                    font-style: italic
                }

                .current_nav_l {
                    // background-image: url("../assets/btn_bg_003.png");
                    // background-image: url("../assets/new_bg_3.png");
                    font-size: 0.33rem;
                    font-family: 045-SSYiFeiTi-Regular, 045-SSYiFeiTi;
                    font-weight: 400;
                    color: #00E0DB;
                }

                .current_nav {
                    // background-image: url("../assets/btn_bg_2.png") !important;
                    background-image: url("../assets/new_bg_4.png") !important;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #032929;
                }
            }

            .title_l {
                // background-image: url("../assets/left.png");
                background-size: 100% 100%;
                // padding-right: .6rem;
                padding-right: .5rem;
                margin-left: .45rem;

                .goback {
                    // margin-top: 0.49rem;
                    display: flex;
                    align-items: center;
                }

                img {
                    width: 0.14rem;
                    height: 0.23rem;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }

                span {
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: rgba(0, 224, 219, 0.97);
                }
            }

            .title_r {
                // background-image: url("../assets/right.png");
                background-size: 100% 100%;
                // padding-left: .6rem;
                // padding-left: .5rem;
                // margin-right: .5rem;

                .time {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    right: -0.15rem;
                    top: 0.2rem;
                    // padding-left: 0.85rem;
                }

                .time label {
                    font-size: 0.1rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #2C75FD;
                    margin-top: 0.15rem;
                }

                .time span {
                    display: block;
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-left: -0.75rem;
                    cursor: pointer;
                    margin-top: 0.2rem;
                }

                .model_item {
                    // background-image: url("../assets/btn_bg_004.png");
                    background-image: url("../assets/new_bg_1.png");
                }
            }
        }

        img {
            height: 0.45rem;
        }

    }
}
</style>